export default __webpack_public_path__ + "static/media/alexa.13c70c88.png";